angular.module('lf.common')

.directive('validEmail', function (validationService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, el, attrs, model) {
      var validator = function (val) {
        var valid = model.$isEmpty(val) || validationService.validateEmail(val);
        model.$setValidity('validEmail', valid);
        return val;
      }
      model.$parsers.push(validator);
      model.$formatters.push(validator);
    }
  }
});
